import { myAxios } from "./axios";

export function getServices(payload = {}, { page, limit } = {}) {
    const config = {
        params: {
            page,
            limit,
            ...payload,
        },
    };
    return myAxios.get("/services", config);
}

export function getService(id) {
    return myAxios.get("/services/" + id);
}

export function addService(data) {
    return myAxios.post("/services/add/", data);
}

export function editService(id, data) {
    return myAxios.put("/services/edit/" + id, data);
}

export function deleteService(id) {
    return myAxios.delete("/services/" + id);
}
